import { render, staticRenderFns } from "./Callout.vue?vue&type=template&id=2734884a&scoped=true"
import script from "./Callout.vue?vue&type=script&lang=js"
export * from "./Callout.vue?vue&type=script&lang=js"
import style0 from "./Callout.vue?vue&type=style&index=0&id=2734884a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2734884a",
  null
  
)

export default component.exports